import React from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faComments from '@fortawesome/fontawesome-free-solid/faComments'
import '../styles/WhatsAppBubble.css'

const whatsappPhone = '33652285392'

const WhatsAppBubble = () => {
  const pathname = typeof window !== 'undefined' && window.location ? window.location.pathname : ''
  const hiddenOnMobile = /^\/(?:team-building|carte-cadeaux)\/?$/.test(pathname)

  return (
    <a
      className={`whatsapp-bubble${hiddenOnMobile ? ' whatsapp-bubble--hidden-mobile' : ''}`}
      href={`https://wa.me/${whatsappPhone}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacter One Hour sur WhatsApp"
      title="WhatsApp"
    >
      <FontAwesomeIcon icon={faComments} />
    </a>
  )
}

export default WhatsAppBubble



// WEBPACK FOOTER //
// ./src/components/WhatsAppBubble.js